import 'react-multi-carousel/lib/styles.css'
import React, { useContext, useEffect, useRef, useState } from 'react'
import AuthContext from 'store/auth-context'
import Image from 'next/image'
import cf from '@/lib/utils/common'
import parse from 'html-react-parser'
import styles from './index.module.css'
import { useRouter } from 'next/router'
import Link from '../../../../common/Link.js'
import { getStorage } from '../../../../common/lib/utils/localStorage'
import CustomLink from '@/components/Link'
import { getCookieTocken } from '@/commonComponents/login/userToken.js'
import { getProfileData } from '../../../lib/myProfile'
const HotelSearchWidget = dynamic(() => import('../../common/hotel/widgets'))
const Carousel = dynamic(() => import('react-multi-carousel'), {
  loading: () => <p>loading...</p>,
  ssr: false,
})
const PromotionBanner = dynamic(() => import('../../promotionBanner/index'))
const AccountOverview = dynamic(() => import('../../PageBreakUp/hotel/AccountOverview'))
const BookingOverview = dynamic(() => import('../../PageBreakUp/hotel/BookingOverview'))
const BalaceSection = dynamic(() => import('../../PageBreakUp/homePage/BalanceSection'))
const BookAndEarn = dynamic(() => import('../../PageBreakUp/homePage/BookAndEarn'))
const QuickAction = dynamic(() => import('../../PageBreakUp/homePage/QuickAction'))
const RecentSearch = dynamic(() => import('../../PageBreakUp/hotel/RecentSearch'))

import {
  myGreetingMySwiper,
  myGreetingMySwiper2,
  myGreetingElevatenew,
  myGreetingCruiseHolidays,
  myGreetingChild_featureSwiper,
  myGreetingTestimonial_data,
  myGreetingMyclientSwiper,
  myGreetingOffermain,
  myGreetingNewlyadded,
  myGreetingMostbooked,
  myGreetingHoneymoonpkg,
  myGreetingExploremain,
  myGreetingBudgetSwiper,
  offerSwiper,
  myGreetingPopularSwiper,
  myGreetingNetworkslider,
  myGreetingCardSwiper,
} from '../../../public/js/carousalFun'
import dynamic from 'next/dynamic'

import static_config from '../../../../common/lib/utils/enum.json'
let upcomingBookings = static_config?.dummy_upcoming_bookings || []

export default function Theme9Flow(props) {
  const ctx = useContext(AuthContext)
  const [activeItemIndex, setActiveItemIndex] = useState(0)
  const wrapperRef = useRef(null)
  const [expandHotelNameBoolean, setExpandHotelName] = useState(false)
  const [getHotelAutoSuggestList, setHotelAutoSuggestList] = useState([])
  const [initHotelData, setInitHotelData] = useState([])
  const [homeBody, setHomeBody] = useState([])
  const [firstNobannerId, setFirstNoBannerId] = useState(null)
  const [lastNobannerId, setLastNoBannerId] = useState(null)
  const [hotelDefultDays, setHotelDefultDays] = useState(0)
  const [userProfile, setUserProfile] = useState('')
  const [SerachWidget, setSerachWidget] = useState('')
  const [SerachWidMob, setSerachWidMob] = useState('')
  const [isActive, setIsActive] = useState('')
  const [recentSearchData, setRecentSearchData] = useState([])
  const [isDesktopDefaultImg, setIsDesktopDefaultImg] = useState(false)
  const [isMobDefaultImg, setIsMobDefaultImg] = useState(false)
  const [section, setSection] = useState('home')
  const [profileData, setprofileData] = useState({})
  const [isProfileData, setIsProfileData] = useState(false)
  const [state, setState] = useState({
    showBreakfast: false,
    showFreeCancellation: false,
    recentSearchClicked: true,
    hotelName: '',
    getDestinationId: '',
    getSearchType: 6,
    property_count: '',
    dest_type: { code: '', text: '' },
  })
  const [bookingList, setBookingList] = useState([])

  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 1,
      // slidesToSlide: 3 // optional, default to 1.
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
      slidesToSlide: 2, // optional, default to 1.
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      slidesToSlide: 1, // optional, default to 1.
    },
  }

  useEffect(() => {
    getProfileDatafun()
    let upcomingBookingList = upcomingBookings?.map((ele) => {
      return {
        ...ele,
        check_in_date: ele.product_info.check_in_date,
        check_out_date: ele.product_info.check_out_date,
        name: ele.product_info.hotel_name,
        rooms: ele.product_info.no_of_rooms,
        adults: ele.product_info.guests[0].adults.length || 1,
      }
    })
    setBookingList(upcomingBookingList)
    let userToken = cf.getCookieTocken('userToken')
    cf.getUserProfile(userToken, props.site_id).then((res) => {
      if (res.status === true) {
        setUserProfile(ctx?.user)
      } else {
        setUserProfile(res)
      }
    })
    updateHomeBody()
    if (props?.home?.data?.data?.body?.desktop) {
      /**FIND FIRST AVILLABLE WIDGET**/

      let defaultService = props.home.data.data.header.menu.filter(
        (ele) => ele.status.toLowerCase() == 'active'
      )
      if (defaultService.length > 0) {
        setSerachWidget(defaultService[0].code)
        setIsActive(defaultService[0].code)
      }

      let defaultImgDesktop = props.home.data.data.body.desktop.filter(
        (ele) => ele.type == 'image_carousal'
      )
      if (defaultImgDesktop.length == 0) {
        setIsDesktopDefaultImg(true)
      }

      let defaultImgMob =
        props?.home?.data?.data?.body?.mobile?.length > 0 &&
        props?.home?.data?.data?.body?.mobile.filter((ele) => ele.type == 'image_carousal')
      if (defaultImgMob.length == 0) {
        setIsMobDefaultImg(true)
      }

      let hotelIndex = props.home.data.data.body.desktop.findIndex(
        (items) => items.type === 'hotel_search'
      )
      if (hotelIndex > -1) {
        setHotelDefultDays(props.home.data.data.body.desktop[hotelIndex].default_days)
      }
    }

    const style = document.createElement('style')
    if (
      !cf.isValueEmpty(props) &&
      !cf.isValueEmpty(props.home) &&
      !cf.isValueEmpty(props.home.data)
    ) {
      style.innerHTML = props.home.data.data.css
      document.head.appendChild(style)
    }
    setActiveItemIndex(activeItemIndex)
    if (!cf.isValueEmpty(props) && !cf.isValueEmpty(props.home) && props.home.status === true) {
      if (
        !cf.isValueEmpty(props.home.data.data) &&
        !cf.isValueEmpty(props.home.data.data.body) &&
        !cf.isValueEmpty(props.home.data.data.body.desktop) &&
        props.home.data.data.body.desktop.length > 0
      ) {
        let hotelIndex = props.home.data.data.body.desktop.findIndex(
          (items) => items.type === 'hotel_search'
        )

        if (hotelIndex !== -1) {
          if (
            !cf.isValueEmpty(props.home.data.data.body.desktop[hotelIndex].locations) &&
            props.home.data.data.body.desktop[hotelIndex].locations.length > 0
          ) {
            setInitHotelData([...props.home.data.data.body.desktop[hotelIndex].locations])
            setHotelAutoSuggestList([...props.home.data.data.body.desktop[hotelIndex].locations])
          }
        }
      }
    }
    if (ctx?.isLoggedIn == true) {
      setTimeout(() => {
        //document?.getElementById('signupContainer')?.style.display = 'none'
      }, 5000)
    }

    let LocalSearch = getStorage('hotelSearchKey')

    let LocalSearchAll = getStorage('hotelSearchKeyAll')

    if (LocalSearchAll != null) {
      setRecentSearchData(JSON.parse(LocalSearchAll))
    }
    if (LocalSearch != null && LocalSearchAll == null) {
      setRecentSearchData([JSON.parse(LocalSearch)])
    }

    document.addEventListener('click', handleClickOutside, false)
    return () => {
      document.removeEventListener('click', handleClickOutside, false)
    }
  }, [])

  useEffect(() => {
    if (recentSearchData && recentSearchData.length > 0) {
      recentSearchData.map((element, index) => {
        if (index == 0) {
          setState({
            showBreakfast: element?.is_breakfast,
            showFreeCancellation: element?.is_free_cancellation,
          })
        }
      })
    }
  }, [recentSearchData])

  useEffect(() => {
    try {
      updateHomeBody()

      if (window.location.pathname == '/hotel' || window.location.pathname == '/hotels') {
        setSerachWidget('hotel')
        setSerachWidMob('hotel')
        setIsActive('hotel')
      }

      // setTimeout(() => {
      //   myGreetingMySwiper(),
      //     myGreetingMySwiper2(),
      //     myGreetingElevatenew(),
      //     myGreetingCruiseHolidays(),
      //     myGreetingChild_featureSwiper(),
      //     myGreetingTestimonial_data(),
      //     myGreetingMyclientSwiper(),
      //     myGreetingOffermain(),
      //     myGreetingNewlyadded(),
      //     myGreetingMostbooked(),
      //     myGreetingHoneymoonpkg(),
      //     myGreetingExploremain(),
      //     myGreetingBudgetSwiper(),
      //     offerSwiper(),
      //     myGreetingPopularSwiper(),
      //     myGreetingNetworkslider(),
      //     myGreetingCardSwiper()
      // }, 100)
    } catch (error) {
      console.log(error)
    }
  }, [query])

  function getProfileDatafun() {
    let data = {
      accessToken:
        getCookieTocken('userToken') !== undefined &&
        getCookieTocken('userToken') !== null &&
        getCookieTocken('userToken') !== ''
          ? getCookieTocken('userToken')
          : '',
      site_id: props.site_id || '',
    }
    getProfileData(data).then((res) => {
      console.log('profileData==>', res)

      if (res && res.data && res.data.data && res.data.data.length > 0) {
        setIsProfileData(true)
        let proData = res.data.data[0]
        setprofileData({ ...proData })
        // setIsLoader(false)
      }
    })
  }

  const updateHomeBody = () => {
    const homeBodyRes = props?.isMobile
      ? props?.home?.data?.data?.body?.mobile
      : props?.home?.data?.data?.body?.desktop
    const firstNobanner = homeBodyRes?.find((item) => item.banner_data === 'nobanner')
    const lastNobanner = homeBodyRes?.filter((item) => item.banner_data === 'nobanner').pop()
    const firstNobannerOrder = firstNobanner ? firstNobanner?.order : null
    const lastNobannerOrder = lastNobanner ? lastNobanner?.order : null
    setHomeBody(homeBodyRes)
    setFirstNoBannerId(firstNobannerOrder)
    setLastNoBannerId(lastNobannerOrder)
  }

  const handleClickOutside = (event) => {
    if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
      if (expandHotelNameBoolean === true) setExpandHotelName(false)
    }
  }

  const imageLoader = ({ src }) => {
    return `${'/shared/api/media/' + props.site_id + '/' + src}`
  }

  const router = useRouter()
  const query = router.query.index

  const copyCouponCode = (id) => {
    if (id) {
      var copyText = document.getElementById(id).innerHTML
      if (copyText) {
        navigator.clipboard.writeText(copyText)
        var copycouponcodeId = 'copycouponcode_' + id
        document.getElementById(copycouponcodeId).innerHTML = 'Copied'
        setTimeout(function () {
          document.getElementById(copycouponcodeId).innerHTML = 'Copy Code'
        }, 3000)
      }
    }
  }

  const renderIcon = (res) => {
    if (SerachWidget === res.code) {
      return (
        <img
          src={`images/${res.code === 'holidays' ? 'holiday' : res.code}_active.svg`}
          alt={res.code}
        />
      )
    }

    return res.icon === '' ? (
      <img src="images/forexImg.svg" alt={res.code} />
    ) : (
      <img src={`/shared/api/media/${props.site_id}/${res.icon}`} alt={res.code} />
    )
  }

  const renderTab = (res) => {
    const isActive =
      SerachWidget === res.code || (SerachWidget === 'holiday' && res.code === 'holidays')
    const tabClass = isActive ? styles.search_widget_tab_active : styles.search_widget_tab_inactive

    return (
      <li
        className={tabClass}
        onClick={() => setSerachWidget(res.code === 'holidays' ? 'holiday' : res.code)}
      >
        <div className={styles.search_widget_icon}>{renderIcon(res)}</div>
        <span className={styles.search_widget_label}>{res.text}</span>
      </li>
    )
  }

  return (
    <>
      {props.isMobile ? (
        <div className={styles.home_container}>
          <h4 className={styles.main__title}>Welcome, Rajeev Rai</h4>
          {props.isMobile && (
            <>
              <BalaceSection
                additionalClassName={''}
                title={'Upcoming Bookings'}
                list={bookingList}
                dateFormat={'MMM DD YYYY'}
                showViewAll={bookingList?.length > 3}
                upcomingVariant={true}
              />
              <BookAndEarn
                additionalClassName={''}
                title={'Upcoming Bookings'}
                list={bookingList}
                dateFormat={'MMM DD YYYY'}
                showViewAll={bookingList?.length > 3}
                upcomingVariant={true}
              />
              <QuickAction
                additionalClassName={''}
                title={'Upcoming Bookings'}
                list={bookingList}
                dateFormat={'MMM DD YYYY'}
                showViewAll={bookingList?.length > 3}
                upcomingVariant={true}
              />
            </>
          )}
        </div>
      ) : (
        <div className={styles.home_container}>
          <div style={{ margin: 0 }}>
            {homeBody.map((res, i) => {
              return (
                <div key={'homeBodyDsktp' + i}>
                  {!cf.isValueEmpty(res.type) &&
                    res.type == 'image_carousal' &&
                    (res.banners && res.banners.length > 0 ? (
                      <div
                        className={`${props.isMobile ? styles.carousal_container : ''}`}
                        style={{ margin: 0 }}
                      >
                        <Carousel
                          swipeable={false}
                          draggable={false}
                          showDots={false}
                          responsive={responsive}
                          ssr={false} // means to render carousel on server-side.
                          infinite={true}
                          autoPlay={props.isMobile ? false : false}
                          autoPlaySpeed={3000}
                          keyBoardControl={true}
                          customTransition="all .5"
                          transitionDuration={500}
                          containerClass={styles.carouse_container2}
                          //  containerClass="carousel-container"
                          // deviceType={this.props.deviceType}
                          dotListClass="custom-dot-list-style"
                          itemClass="carousel-item-padding-40-px"
                        >
                          {!cf.isValueEmpty(res) &&
                            !cf.isValueEmpty(res.banners) &&
                            res.banners.length > 0 &&
                            res.banners.map((imagedata, index) => {
                              return (
                                <div
                                  style={{ margin: 0 }}
                                  key={'banner' + index}
                                  className={styles.img_banner_home2}
                                >
                                  <CustomLink href={imagedata.banner_url}>
                                    <Image
                                      loader={imageLoader}
                                      src={props?.isMobile ? imagedata?.r_image : imagedata?.image}
                                      width={500}
                                      layout="fill"
                                      alt="image-carousel"
                                    />
                                  </CustomLink>
                                </div>
                              )
                            })}
                        </Carousel>
                      </div>
                    ) : (
                      <div className={styles.nobanner}></div>
                    ))}
                </div>
              )
            })}
          </div>

          <div className={`${styles.hotel_widget_container}`}>
            <div
              className={`${styles.hotel_widget_parent} ${styles.hotel_widget_parent_container}`}
            >
              <div
                className={`${styles.hotel_widget_wrap} ${
                  SerachWidget === 'hotel' ? styles.hotel_widget_search : styles.hotel_widget_home
                }`}
              >
                <div className={styles.search_widget_container}>
                  <div className={styles.search_widget}>
                    <div className={styles.search_widget_navbar_row}>
                      <div className={styles.search_widget_carousel_container}>
                        <nav className={styles.search_widget_navbar}>
                          <ul className={styles.search_widget_tabs}>
                            {props?.home?.data?.data?.header?.menu
                              .filter((ele) => ele.status.toLowerCase() === 'active')
                              .slice(0, 7)
                              .map((res) =>
                                res.code !== 'others' ? (
                                  <Link key={res.code} title={res.text} href={res.url}>
                                    {renderTab(res)}
                                  </Link>
                                ) : (
                                  <a key={res.code} title={res.text} href={res.url}>
                                    <li
                                      className={
                                        SerachWidget === 'others'
                                          ? styles.search_widget_tab_active
                                          : styles.search_widget_tab_inactive
                                      }
                                    >
                                      <div className={styles.search_widget_icon}>
                                        {res.icon === '' ? (
                                          <img src="images/forexImg.svg" alt={res.code} />
                                        ) : (
                                          <img
                                            src={`/shared/api/media/${props.site_id}/${res.icon}`}
                                            alt={res.code}
                                          />
                                        )}
                                      </div>
                                      {res.text}
                                    </li>
                                  </a>
                                )
                              )}
                          </ul>
                        </nav>
                      </div>
                    </div>
                  </div>
                </div>

                <div className={styles.search_widget_body}>
                  {homeBody.map((res, i) => {
                    return (
                      <div key={'homeBodyDsktp' + i}>
                        {SerachWidget === 'hotel' && res.type == 'hotel_search' && (
                          <div>
                            <HotelSearchWidget
                              isMobile={props.isMobile}
                              checkinFormat={'dd MMM yyyy'}
                              checkoutFormat={'dd MMM yyyy'}
                              query={router.query}
                              cmsPopularData={[]}
                            />
                          </div>
                        )}
                      </div>
                    )
                  })}
                </div>
              </div>
            </div>
          </div>

          <div className={styles.hotel_widget_acc_overview}>
            <AccountOverview additionalClassName={''} />
          </div>

          <div className={styles.hotel_widget_upcoming_bookings}>
            {isProfileData && (
              <RecentSearch
                props={props}
                additionalClassName={''}
                title={'Recent Searches'}
                list={bookingList}
                dateFormat={'MMM DD YYYY'}
                showViewAll={false}
                upcomingVariant={false}
                profileData={profileData}
                isProfileData={isProfileData}
              />
            )}
          </div>

          <div className={styles.hotel_widget_upcoming_bookings}>
            {isProfileData && (
              <BookingOverview
                props={props}
                additionalClassName={''}
                title={'Upcoming Bookings'}
                list={bookingList}
                dateFormat={'MMM DD YYYY'}
                showViewAll={bookingList?.length > 3}
                upcomingVariant={true}
                profileData={profileData}
                isProfileData={isProfileData}
              />
            )}
          </div>

          {/* Recent Search Section end ==> */}
          <div>
            {homeBody.map((res, i) => {
              return (
                <div key={'homeBodyDsktp' + i}>
                  {res?.type == 'promotion_banner' ? (
                    <PromotionBanner
                      isMobile={props?.isMobile}
                      responsive={responsive}
                      res={res}
                      imageLoader={imageLoader}
                      cssstyles={styles}
                    />
                  ) : (
                    <div
                      className={
                        firstNobannerId == res.order
                          ? styles.firstnobanner
                          : res.order == lastNobannerId
                            ? styles.lastnobanner
                            : ''
                      }
                    >
                      {!cf.isValueEmpty(res.html)
                        ? parse(res.html, {
                            replace: ({ attribs }) => {
                              if (attribs && attribs.copycouponcode === 'copy') {
                                return (
                                  <p
                                    class="copyZth"
                                    copycouponcode="copy"
                                    copycouponcodevalue={attribs.copycouponcodevalue}
                                    copycouponcodenumber={attribs.copycouponcodenumber}
                                    id={attribs.id}
                                    onClick={() => copyCouponCode(attribs.copycouponcodenumber)}
                                  >
                                    Copy Code
                                  </p>
                                )
                              }
                            },
                          })
                        : ''}
                    </div>
                  )}
                </div>
              )
            })}
          </div>
        </div>
      )}
    </>
  )
}
